var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7595 23.7191C13.7595 22.4784 14.7319 21.4791 16.0169 21.4791C17.2671 21.4791 18.2395 22.4784 18.2395 23.7191C18.2395 24.9597 17.2671 25.9591 16.0169 25.9591C14.7319 25.9591 13.7595 24.9597 13.7595 23.7191Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 13.759C14.7622 13.759 13.7593 14.7619 13.7593 15.999C13.7593 17.2362 14.7622 18.239 15.9993 18.239C17.2364 18.239 18.2393 17.2362 18.2393 15.999C18.2393 14.7619 17.2364 13.759 15.9993 13.759Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7595 8.27906C13.7595 7.03845 14.7045 6.03906 15.9645 6.03906C17.2945 6.03906 18.2395 7.03845 18.2395 8.27906C18.2395 9.51968 17.2945 10.5191 15.9645 10.5191C14.7395 10.5191 13.7595 9.51968 13.7595 8.27906Z",
    fill: "#666666"
  })));
};
export default SvgMore;